import { setPhotoMargin } from "../utils";

const ImageGrid = ({ photos, staff, owner, userId, navigate, viewPhotos }) => {
    let headerImage = [];
    let gridImages = [];

    if (!photos.length) {
        headerImage = [
            <div
                className="mr-1 bg-gray-200"
                style={{
                    height: 500,
                    gridRowStart: null,
                    gridColumnStart: null,
                    backgroundSize: "cover",
                    backgroundPosition: "top",
                }}
            ></div>,
        ];
        gridImages = [0, 1, 2, 3].map((p, i) => (
            <div
                className={`${setPhotoMargin(i)} bg-gray-200`}
                style={{
                    gridRowStart: null,
                    gridColumnStart: null,
                    backgroundSize: "cover",
                    backgroundPosition: "top",
                }}
            ></div>
        ));
    } else if (photos.length === 1) {
        headerImage = [
            <div
                className="mr-1"
                style={{
                    backgroundImage: `url("${photos[0].cdn_url}")`,
                    height: 500,
                    gridRowStart: null,
                    gridColumnStart: null,
                    backgroundSize: "cover",
                    // backgroundPosition: "top",
                }}
            ></div>,
        ];
        gridImages = [0, 1, 2, 3].map((p, i) => (
            <div
                className={`${setPhotoMargin(i)} bg-gray-200`}
                style={{
                    gridRowStart: null,
                    gridColumnStart: null,
                    backgroundSize: "cover",
                    backgroundPosition: "top",
                }}
            ></div>
        ));
    } else if (photos.length > 1) {
        headerImage = [
            <div
                className="mr-1"
                style={{
                    backgroundImage: `url("${photos[0].cdn_url}")`,
                    height: 500,
                    gridRowStart: null,
                    gridColumnStart: null,
                    backgroundSize: "cover",
                    // backgroundPosition: "top",
                }}
            ></div>,
        ];
        gridImages = photos.slice(1).map((p, i) => (
            <div
                className={`${setPhotoMargin(i)}`}
                style={{
                    backgroundImage: `url("${p.cdn_url}")`,
                    gridRowStart: null,
                    gridColumnStart: null,
                    backgroundSize: "cover",
                    backgroundPosition: "top",
                }}
            ></div>
        ));

        const gridDiff = 4 - gridImages.length;
        for (let i = 0; i < gridDiff; i++) {
            gridImages.push(
                <div
                    className={`${setPhotoMargin(i + gridDiff)} bg-gray-200`}
                    style={{
                        gridRowStart: null,
                        gridColumnStart: null,
                        backgroundSize: "cover",
                        backgroundPosition: "top",
                    }}
                ></div>
            );
        }
    }

    return (
        <div className="hidden md:grid grid-cols-2 h-full relative z-10 heap-ignore">
            {headerImage}
            <div className="grid grid-cols-2 grid-rows-2">{gridImages}</div>
            <button
                onClick={() => {
                    if (staff) {
                        navigate(`/staff/split-members/${userId}/public-profile/photos`);
                    } else if (owner) {
                        viewPhotos();
                    } else {
                        navigate(`/family/donors/${userId}/photos`);
                    }
                }}
                className="text-secondary font-normal absolute bottom-1 right-0 py-3 px-4 m-2 bg-white text-black rounded-full z-10"
            >
                View Photos
            </button>
        </div>
    );
};

export default ImageGrid;
